import { useEffect, useState } from "react";
import env from "config";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import Pricing from "../Saas/Pricing";

function PremiumStep({ onReady }) {
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [products, setProducts] = useState([]);
  const [potentialProducts, setPotentialProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const stripeConnected = Boolean(agency?.stripe);

  const loadPlans = async () => {
    if (!agency?._id) return;
    setLoading(true);
    try {
      const [plans, potential] = await Promise.all([
        AppService.saas.agencysaas({
          query: `agency_id=${agency._id}`,
          toaster: false,
        }),
        AppService.saas.potentialproducts({
          query: `agency_id=${agency._id}`,
          toaster: false,
        }),
      ]);
      setProducts(plans?.response?.data || []);
      setPotentialProducts(potential?.response || []);
    } catch (error) {
      console.error("Failed to load plans for onboarding", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPlans();
  }, [agency?._id]);

  useEffect(() => {
    onReady?.(stripeConnected && products.length > 0);
  }, [stripeConnected, products.length, onReady]);

  const stripeUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${env.STRIPE_CONNECT_CLIENT_ID}&scope=read_write&redirect_uri=${encodeURIComponent(env.STRIPE_CONNECT_REDIRECT_URI)}&state=${agency?._id}`;

  return (
    <div className="sd-onboarding__premium">
      <div className="sd-onboarding__stripe">
        <div>
          <h3>Stripe</h3>
          <p>
            {stripeConnected
              ? "Stripe is connected. Add a premium plan with a price, then continue."
              : "Connect Stripe in a new tab. This screen updates when the connection is saved."}
          </p>
        </div>
        {stripeConnected ? (
          <span className="sd-onboarding__badge">Connected</span>
        ) : (
          <a className="sd-onboarding__link-btn" href={stripeUrl} target="_blank" rel="noreferrer">
            Connect Stripe
          </a>
        )}
      </div>

      {stripeConnected &&
        (loading ? (
          <p className="sd-onboarding__note">Loading plans...</p>
        ) : (
          <Pricing
            data={products}
            potentialproducts={potentialProducts}
            handleRefresh={loadPlans}
          />
        ))}
    </div>
  );
}

export default PremiumStep;
